
export default {
  name: 'SingleTab',
  props: {
    title: {
      type: String,
      default: '微信登录'
    }
  }
}
